import { yupResolver } from "@hookform/resolvers/yup";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import { formValidate } from "helpers/form_helper";
import { useChangePassword } from "hooks";
import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Label,
  Row,
} from "reactstrap";
import { AUTH_TOKEN, FORCE_CHANGE_PASS } from "store/auth/login/actionTypes";
import * as yup from "yup";

const ChangePassword = props => {
  const { t } = useTranslation("translation");
  const navigate = useNavigate();

  const { mutate: onChangeUpdatePassword } = useChangePassword(() => {
    navigate("/logout");
    localStorage.removeItem(FORCE_CHANGE_PASS);
  });

  const initDefaultField = {
    old_password: "",
    new_password: "",
    confirm_password: "",
  };

  const schema = yup.object().shape({
    old_password: yup
      .string()
      .required(t("form.validate.required", { title: t("form.old_password") })),
    new_password: yup
      .string()
      .required("Vui lòng nhập mật khẩu mới")
      .min(8, "Mật khẩu phải có ít nhất 8 ký tự") // Độ dài tối thiểu
      .matches(/[A-Z]/, "Mật khẩu phải chứa ít nhất 1 chữ cái in hoa (A-Z)") // Chữ in hoa
      .matches(/[a-z]/, "Mật khẩu phải chứa ít nhất 1 chữ cái in thường (a-z)") // Chữ in thường
      .matches(/\d/, "Mật khẩu phải chứa ít nhất 1 chữ số (0-9)") // Chữ số
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "Mật khẩu phải chứa ít nhất 1 ký tự đặc biệt (!, @, #, $, %, ^, &...)"
      ) // Ký tự đặc biệt
      .notOneOf(
        [yup.ref("old_password")],
        "Mật khẩu mới phải khác mật khẩu hiện tại"
      ),
    confirm_password: yup
      .string()
      .required(
        t("form.validate.required", { title: t("form.confirm_password") })
      )
      .oneOf([yup.ref("new_password")], t("form.validate.not_match")),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: initDefaultField,
  });

  const onChangePassword = values => {
    onChangeUpdatePassword({ data: values });
  };

  useEffect(() => {
    if (!localStorage.getItem(AUTH_TOKEN)) {
      navigate("/login");
    }
  }, []);

  return (
    <React.Fragment>
      <div className="home-btn d-none d-sm-block">
        <Link to="/" className="text-dark">
          <i className="fas fa-home h2" />
        </Link>
      </div>
      <div className="account-pages my-5 pt-sm-5">
        <Container>
          <Row className="justify-content-center">
            <Col md="8" lg="6" xl="5">
              <Card className="overflow-hidden">
                <div className="bg-primary bg-soft">
                  <Row>
                    <Col xs="12">
                      <div className="text-primary p-4">
                        <h5 className="text-primary">Thay đổi mật khẩu</h5>
                        <p className="text-primary">
                          Hệ thống quản lý logistics Gene Solutions
                        </p>
                      </div>
                    </Col>
                    <Col xs="5" className="align-self-end"></Col>
                  </Row>
                </div>
                <CardBody className="pt-0">
                  <div>
                    <Link to="/">
                      <div className="avatar-md profile-user-wid mb-4">
                        <span className="avatar-title rounded-circle bg-light">
                          <i
                            style={{ fontSize: "46px" }}
                            className="bx bxs-lock-alt align-middle me-1 text-info"
                          />
                        </span>
                      </div>
                    </Link>
                  </div>
                  <div className="p-2">
                    <div className="form-horizontal">
                      <div
                        className="user-thumb mb-3"
                        style={{
                          padding: "0px 10px",
                          fontSize: "14px",
                        }}
                      >
                        {/* <img
                          //   src={avatar}
                          className="rounded-circle img-thumbnail avatar-md"
                          alt="thumbnail"
                        /> */}
                        {/* <h5 className="font-size-15 mt-3">
                          Mật khẩu mới phải khác mật khẩu cũ
                        </h5> */}
                        * Sử dụng 8 ký tự trở lên bao gồm chữ hoa, chữ thường,
                        số, ký tự đặc biệt
                      </div>

                      <Row className="row-cols-1">
                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="old_password">
                              {t("form.old_password")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <input
                              type="text"
                              className={`form-control ${formValidate(
                                errors,
                                touchedFields,
                                "old_password"
                              )}`}
                              placeholder={t("placeholder.enter", {
                                title: t("form.old_password"),
                              })}
                              {...register("old_password")}
                            />
                            {errors.old_password && (
                              <MessageFormValidate
                                error={errors.old_password.message}
                              />
                            )}
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="new_password">
                              {t("form.new_password")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <input
                              type="text"
                              className={`form-control ${formValidate(
                                errors,
                                touchedFields,
                                "new_password"
                              )}`}
                              placeholder={t("placeholder.enter", {
                                title: t("form.new_password"),
                              })}
                              {...register("new_password")}
                            />
                            {errors.new_password && (
                              <MessageFormValidate
                                error={errors.new_password.message}
                              />
                            )}
                          </FormGroup>
                        </Col>

                        <Col>
                          <FormGroup className="mb-3">
                            <Label htmlFor="confirm_password">
                              {t("form.confirm_password")}{" "}
                              <span className="text-danger">*</span>
                            </Label>
                            <input
                              type="text"
                              className={`form-control ${formValidate(
                                errors,
                                touchedFields,
                                "confirm_password"
                              )}`}
                              placeholder={t("placeholder.enter", {
                                title: t("form.confirm_password"),
                              })}
                              {...register("confirm_password")}
                            />
                            {errors.confirm_password && (
                              <MessageFormValidate
                                error={errors.confirm_password.message}
                              />
                            )}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row className="justify-content-end">
                        <Col className="col-auto">
                          <Button
                            color="primary"
                            className="btn-label"
                            type="button"
                            onClick={() => {
                              handleSubmit(onChangePassword)();
                            }}
                          >
                            <i className="far fa-save fa-lg label-icon"></i>
                            {t("form.save")}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ChangePassword.propTypes = {};

ChangePassword.defaultProps = {};

export default ChangePassword;
